module.exports = __webpack_public_path__ + "static/media/bcard-202009-1.901767c7.jpg";